function getISOWeekNumber(date: Date): number {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

export function initHero(): void {
    const dateEl = document.getElementById('hero-date');
    const greetingEl = document.getElementById('hero-greeting');
    if (!dateEl || !greetingEl) return;

    const weekEl = document.getElementById('hero-week');
    if (!weekEl) return;

    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Helsinki' }));
    const weekNumber = getISOWeekNumber(now);
    const weekdayPart = new Intl.DateTimeFormat('fi-FI', { weekday: 'long', timeZone: 'Europe/Helsinki' }).formatToParts(new Date())
        .find(p => p.type === 'weekday');
    const weekday = weekdayPart ? weekdayPart.value.replace(/na$/, '') : 'Päivä';
    const restOfDate = new Date().toLocaleDateString('fi-FI', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Europe/Helsinki',
    });
    dateEl.textContent = `${weekday} ${restOfDate}`;
    weekEl.textContent = `Viikko ${weekNumber}`;

    const hour = now.getHours();
    const dayOfWeek = now.getDay();
    const month = now.getMonth();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    const morningMessages = [
        "Rise and shine — or just rise. Shining is optional.",
        "Today's to-do list: 1) coffee 2) everything else.",
        "You're vertical. That's 90% of the battle.",
        "Good morning! Your bed already misses you.",
        "Coffee loading… please do not unplug the human.",
        "Another day, another mass transit adventure.",
        "Remember: you chose to set that alarm. Respect the decision.",
        "Congratulations on not hitting snooze. Or did you?",
        "Your brain will arrive in approximately 15 minutes.",
        "Good morning! Today's forecast: 100% chance of decisions.",
        "Plot twist: it's morning again.",
        "A wizard placed a curse on you. The curse is called 'employment'.",
        "Your consciousness has been rebooted in safe mode.",
        "Fun fact: 73% of this morning is sponsored by caffeine and denial.",
        "Somewhere, a rooster is taking credit for your alarm clock.",
        "Your eyes are open. Legal disclaimer: this is not medical advice.",
        "According to my calculations, you could have slept 4 more minutes.",
        "Breaking news: local human leaves horizontal position. Nation stunned.",
        "You are now the CEO of Being Awake. Congratulations. No salary.",
        "The floor is cold. This is a test of character.",
        "Your bed filed a missing persons report.",
        "Morning checklist: breathing ✓, blinking ✓, functioning… pending.",
        "You beat the sunrise. It didn't even try.",
        "Your alarm clock just asked if you two are still friends.",
        "Today's motivation level: let's see after the second coffee.",
        "The snooze button was right there and you didn't press it. Hero.",
        "You have been promoted to 'awake'. Benefits include coffee.",
        "Your toothbrush has been expecting you. Don't make it weird.",
        "A small council of neurons voted 3-2 in favor of consciousness. The motion barely passed.",
        "Your skeleton is wet right now. You're welcome for that thought.",
        "Gravity is personally victimizing you this morning. File a complaint with physics.",
        "Your mirror just sighed. It's been a long night for both of you.",
        "The sun rose without your permission. How dare it.",
        "You're one coffee away from being a functioning member of society.",
        "Your body is 60% water and 40% reluctance right now.",
        "Somewhere a motivational poster is lying about this being your day.",
        "Your shower is about to give you the best ideas you'll never act on.",
        "The birds outside are screaming. They call it 'singing'. Agree to disagree.",
        "Your cereal is judging your life choices. The milk agrees.",
        "You just unlocked the 'vertical mammal' achievement. Don't let it go to your head.",
        "The universe expanded today. You, however, are trying to contract back into bed.",
        "Your pillow is writing a memoir about your sleep habits. It's unflattering.",
        "Technically you're alive. Let's not oversell it.",
        "Your coffee maker is the only appliance that truly understands you.",
        "Somewhere a productivity guru is waking up at 4 AM. You are not that person.",
        "The sun is up. You are up. Correlation is not causation.",
        "Your morning face is a work in progress. An abstract one.",
        "Congratulations on achieving consciousness. The hard part is over. The rest is just... everything.",
        "Your autopilot engaged. Destination: kitchen. ETA: whenever your legs cooperate.",
        "Today's energy level: library computer from 2003.",
        "Your dreams were weird. Don't google what they mean. Trust me.",
        "The snooze button filed for early retirement after your abuse.",
        "Your future biographer will skip this chapter. Make it interesting.",
        "The morning air is fresh. Your attitude is stale. Balance.",
        "You have 16 hours until bed. Pace yourself accordingly.",
        "Your reflection just mouthed 'good luck' at you. Concerning.",
        "According to quantum physics, there's a universe where you're still asleep. Lucky you. Other you.",
        "The toaster is the most supportive appliance in your house. It only knows how to make things warmer.",
        "Your morning routine is technically a speedrun. No one's keeping score though.",
        "Today's challenge: pretend you read that article you bookmarked three weeks ago.",
        "You woke up on the right side of the bed. Bold of you to assume there's a wrong one.",
        "Every morning is a fresh start. Except Mondays. Those are cursed.",
        "Your phone has 14 notifications. None of them are good. Check anyway.",
        "The early bird gets the worm. You get coffee. You win.",
        "Your morning commute is a meditation practice. An angry one.",
        "Oxygen: inhaled. Coffee: pending. Day: negotiable.",
        "You're not a morning person. You're a morning hostage.",
        "Today's forecast: partly existential with a chance of productivity.",
        "Your alarm was an act of violence. You survived. Barely.",
        "Your brain's startup sequence is currently at 12%. Please wait.",
        "Morning status: existentially confused but physically present.",
        "The ceiling looks different when it's voluntary. Enjoy the novelty.",
        "Your morning face has filed for witness protection.",
        "Congratulations: you've achieved the minimum viable consciousness.",
        "Fun fact: your pillow has a five-star review of you. Very clingy.",
        "The kettle is the only coworker who's genuinely happy to see you.",
    ];

    const afternoonMessages = [
        "Lunch coma survival tip: stand up and walk somewhere.",
        "Afternoon: when your ambition meets your energy bill.",
        "You've made it past noon. Statistically, that's impressive.",
        "The afternoon slump is a feature, not a bug.",
        "Your morning self made promises. Good luck with those.",
        "If you're reading this, you survived the morning meeting.",
        "Post-lunch productivity is a myth. But try anyway.",
        "Your inbox has feelings and they're all passive-aggressive.",
        "Time moves slower after lunch. Scientists can't explain it either.",
        "2 PM: the hour when coffee becomes a personality trait.",
        "The afternoon wants you to know it believes in you. It's lying.",
        "You're halfway through the day. The day is also halfway through you.",
        "A nap would fix this. Unfortunately, society disagrees.",
        "Your chair has absorbed more of your life force than any vampire could.",
        "Your productivity peaked at 10 AM. It's been downhill since.",
        "The vending machine knows you by name now. Reflect on that.",
        "Your browser has 47 tabs open. So does your brain.",
        "3 PM: the hour your motivation sends a polite resignation letter.",
        "The office plant is judging your water intake.",
        "Ctrl+Z doesn't work on life decisions. We checked.",
        "Your desk and your existential dread have formed a support group. You're the topic.",
        "The office WiFi knows more about your browsing habits than your therapist. Think about it.",
        "You've spent more time choosing lunch than planning your career. Priorities.",
        "The printer jammed again. It senses weakness.",
        "Your afternoon snack has more emotional depth than most of your meetings.",
        "You're running on caffeine, spite, and a vague sense of obligation.",
        "The clock is moving backwards. This is not a metaphor.",
        "Your inbox just sent you a sympathy card.",
        "You've hit the part of the day where enthusiasm becomes archaeology.",
        "Somewhere in a parallel universe, you took the nap. Envy that version of you.",
        "Your afternoon tea is just anxiety in a mug. Sip it anyway.",
        "The sun is at its highest. Your motivation is at its lowest. Physics is cruel.",
        "Your lunch break ended 47 minutes ago. Your soul hasn't returned yet.",
        "The afternoon is where good intentions go to be rescheduled.",
        "You just checked the time. It's still the same hour. Time is broken.",
        "Your concentration span and a goldfish are in a dead heat.",
        "2:30 PM is the Bermuda Triangle of productivity. Things just vanish.",
        "Your eyes are open but your brain logged out an hour ago.",
        "The afternoon sun is mocking you through the window. It knows you're stuck inside.",
        "You've answered 'I'm good' to twelve people today. You lied eleven times.",
        "Your posture just emailed HR to file a complaint.",
        "The meeting could have been an email. The email could have been silence.",
        "Your screen time report is about to commit a hate crime against your ego.",
        "The office thermostat is a democracy where everyone loses.",
        "Your to-do list is now a to-didn't list. Rebrand it.",
        "You're three snacks deep and the day isn't over. Pacing is a myth.",
        "The afternoon called. It wants its enthusiasm back. You can't return what you never had.",
        "Your chair has more support than your career plan. Lean into it. Literally.",
        "The clock is gaslighting you. Those were not five minutes.",
        "You've reached the point where water tastes boring but coffee feels aggressive.",
        "Your afternoon is powered by residual morning caffeine and pure spite.",
        "You just zoned out so hard your screensaver almost activated. The human one.",
        "The vending machine is your 3 PM therapist. It never judges, only dispenses.",
        "Autopilot engaged. Consciousness optional until 5 PM.",
        "Your lunch has achieved room temperature and so has your enthusiasm.",
        "The afternoon is just the morning's hangover.",
        "Your keyboard spacebar is doing 90% of the work. Respect it.",
        "3:30 PM: the hour your eyes and your screen enter a staring contest.",
        "Your motivational poster is sweating. Even it can't carry this afternoon.",
        "You just typed 'regards' with the passion of a deflating balloon.",
        "The sun moved. You didn't. Nature noticed.",
    ];

    const eveningMessages = [
        "Pajama o'clock approaches. Stay strong.",
        "Fun fact: your couch has been waiting for you all day.",
        "Evening mode: snacks, silence, and zero regrets.",
        "You made it through the day. That's not nothing.",
        "Tonight's agenda: absolutely nothing productive.",
        "Your bed is warming up. Just a few more hours.",
        "The fridge is calling. Don't fight it.",
        "You've unlocked the 'horizontal mode' achievement. Use it wisely.",
        "The microwave is the evening's sous chef. Accept it.",
        "Your brain has switched to screensaver mode. Jiggle the mouse.",
        "Tonight's forecast: 100% chance of staring at a screen and calling it 'relaxing'.",
        "You survived capitalism for another day. Treat yourself to cheese.",
        "The dishes can wait. They have nowhere to be.",
        "Netflix is loading. So is your excuse for staying up late.",
        "Your phone battery and your social energy are at the same level.",
        "Tomorrow's problems are tomorrow's. Tonight, you rest.",
        "You've earned the right to do absolutely nothing. Exercise it.",
        "The couch has accepted your application. Onboarding starts now.",
        "Your slippers have entered the chat.",
        "Dinner plan: whatever requires the fewest dishes.",
        "Your refrigerator light is the only spotlight you'll stand in tonight. Own it.",
        "You just yawned reading this. Your body is staging a coup.",
        "Every cell in your body has agreed to do the absolute minimum. Democracy works.",
        "You've peaked. It was subtle, but it happened. Now enjoy the plateau.",
        "Your evening plans include staring at a wall and calling it 'decompressing'.",
        "The remote control is closer than your ambitions right now.",
        "You're about to make a snack you'll eat standing up in the dark. Own it.",
        "Your future self will judge tonight's decisions. Present self doesn't care.",
        "The blanket has you now. Resistance is futile.",
        "You've earned the right to opinions about nothing and everything. Use them wisely.",
        "Your evening outfit is a horizontal upgrade of your afternoon outfit.",
        "The fridge light is your evening spotlight. Take a bow.",
        "You're about to watch 'just one more episode.' We both know how this ends.",
        "Your evening playlist is just the sound of you sighing repeatedly. Album of the year.",
        "The dishes in the sink have formed a civilization. Don't disturb them.",
        "You just checked the time to see if it's too early for bed. It's 8:14 PM. The answer is yes. But also no.",
        "Tonight's workout: lifting the remote and doing emotional reps.",
        "Your evening brain has the processing power of a calculator watch.",
        "The pajamas were a statement. The statement is 'I'm done.'",
        "You've entered the 'too tired to sleep' paradox. Good luck.",
        "Your phone charger is the only cord keeping you connected to tomorrow.",
        "The evening news exists to make your problems feel smaller. It's working backwards tonight.",
        "Your couch cushion has a permanent impression of you. Call it art.",
        "The WiFi signal is stronger than your will to do anything. Lean into it.",
        "Your fridge just offered emotional support. It's all it has.",
        "You've reached the 'staring at the open fridge hoping for inspiration' phase.",
        "Your evening ambition peaked at 'I'll just sit here.' Mission accomplished.",
        "The throw blanket has become load-bearing. Do not remove.",
        "Tonight's inner monologue is just elevator music and grocery lists.",
    ];

    const weekendMessages = [
        "It's the weekend — no rush, no deadlines.",
        "No alarm tomorrow either. Life is beautiful.",
        "Weekend plan: do absolutely nothing, and then rest afterwards.",
        "Saturday called. It has no plans either.",
        "The weekend: when time moves at the correct speed.",
        "You have approximately 48 hours of freedom. Use them to nap.",
        "Pants are now optional. This is peak civilization.",
        "The weekend is a social contract that you will accomplish nothing.",
        "Your weekend has no terms and conditions. Read them anyway.",
        "Sunday will arrive whether you're ready or not. It never is.",
        "You're one bad decision away from ordering a third pizza. The weekend enables this.",
        "Your alarm didn't go off because it respects you. Finally.",
        "The couch has reserved your usual seat. VIP access granted.",
        "Weekend productivity hack: redefine productivity to include napping.",
        "Your weekend is a blank canvas. You're about to paint it with absolutely nothing.",
        "Brunch is just breakfast that believes in itself. Support its dreams.",
        "The weekend has no loading screen. You're already in it.",
        "Your weekend personality just clocked in. Weekday you has left the building.",
        "Saturday morning cartoons are gone but the spirit of doing nothing remains.",
        "The only deadline today is when the pizza place closes.",
        "Your weekend plans and a blank page have a lot in common.",
        "The grocery store can wait. Everything can wait. You are the priority.",
        "Weekend rule #1: if it requires pants, it can wait until Monday.",
        "Your sleep schedule just declared independence. Let it be free.",
        "The weekend is nature's way of saying 'you've earned the right to be horizontal.'",
    ];

    const springMessages = [
        "The snow is finally retreating. Victory is near.",
        "Spring: when Finland goes from -10° to +10° and everyone wears shorts.",
        "The birds are back. They seem confused too.",
        "The sun exists! This is not a drill!",
        "Mud season: nature's way of saying 'not yet'.",
        "A Finnish spring: where you experience all four seasons before lunch.",
    ];

    const winterMessages = [
        "The sun set at 3 PM, but your spirit is unbreakable.",
        "It's dark, it's cold, and yet here you are. Legend.",
        "Winter tip: if you can't see the sun, it can't see you slacking.",
        "Somewhere under all that ice, spring is plotting a comeback.",
        "Today's UV index: imaginary.",
        "The darkness is not a bug. It's a Finnish feature.",
        "Vitamin D is now a rumor your body vaguely remembers.",
        "It's so dark outside that even your shadow called in sick.",
        "The sun has a restraining order against Finland right now. Respect the legal process.",
    ];

    const seriousMessages = [
        "You are exactly where you need to be. Trust the process.",
        "Small steps still move you forward. Keep going.",
        "You don't have to be perfect today. Just present.",
        "The world is better with you in it. Remember that.",
        "Breathe. You've handled hard days before. You'll handle this one too.",
        "Not every day needs to be productive. Some days, surviving is enough.",
        "You are more resilient than you give yourself credit for.",
        "Take it one hour at a time if you need to. That's valid.",
        "Whatever you're carrying today, you don't have to carry it alone.",
        "Be kind to yourself. You're doing better than you think.",
    ];

    let pool: string[];
    if (hour < 12) pool = morningMessages;
    else if (hour < 17) pool = afternoonMessages;
    else pool = eveningMessages;

    if (isWeekend) pool = pool.concat(weekendMessages);
    if (month >= 2 && month <= 4) pool = pool.concat(springMessages);
    if (month === 11 || month <= 1) pool = pool.concat(winterMessages);
    pool = pool.concat(seriousMessages);

    greetingEl.textContent = pool[Math.floor(Math.random() * pool.length)];
}
